module.exports = __webpack_public_path__ + "img/telegram.96188f38.png";